import { render } from "./field_context_submenu.vue?vue&type=template&id=248f7aa7"
import script from "./field_context_submenu.vue?vue&type=script&lang=js"
export * from "./field_context_submenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/field_context_submenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "248f7aa7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('248f7aa7', __exports__)) {
    api.reload('248f7aa7', __exports__)
  }
  
  module.hot.accept("./field_context_submenu.vue?vue&type=template&id=248f7aa7", () => {
    api.rerender('248f7aa7', render)
  })

}


export default __exports__